import { theme } from '../theme.js';

const NAVY = '#13223f';
const BLUE = '#2196f3';

/** The app mark — same drawing as public/icons/icon.svg. */
export function LogoMark({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" aria-hidden="true" style={{ flexShrink: 0, display: 'block' }}>
      <rect width="512" height="512" rx="112" fill={NAVY} />
      <g fill="none" stroke={BLUE} strokeWidth="18" strokeLinecap="round">
        <path d="M95.5,143.5 A196,196 0 0 1 416.5,143.5" />
        <path d="M78.4,173.1 A196,196 0 0 0 173.2,433.6" />
        <path d="M433.6,173.1 A196,196 0 0 1 338.9,433.6" />
      </g>
      <circle cx="152" cy="196" r="36" fill="#f47a2a" />
      <path d="M88,300 C88,264 116,244 152,244 C188,244 216,264 216,300 Z" fill="#f47a2a" />
      <circle cx="360" cy="196" r="36" fill="#fbc02d" />
      <path d="M296,300 C296,264 324,244 360,244 C396,244 424,264 424,300 Z" fill="#fbc02d" />
      <g fill="#ffffff" stroke={NAVY} strokeWidth="12" paintOrder="stroke">
        <circle cx="256" cy="168" r="48" />
        <path d="M170,302 C170,254 206,226 256,226 C306,226 342,254 342,302 Z" />
      </g>
      <circle cx="256" cy="336" r="72" fill={NAVY} />
      <g fill="none" stroke={BLUE} strokeWidth="14" strokeLinecap="round">
        <path d="M228.1,355.5 A34,34 0 1 1 283.9,355.5" />
        <path d="M210.1,368.1 A56,56 0 1 1 301.9,368.1" />
      </g>
      <path d="M239,428 L239,346 A17,17 0 0 1 273,346 L273,396 C273,382 297,382 297,396 C297,386 319,386 319,402 C319,394 339,396 339,412 L339,446 C339,470 318,484 292,484 L268,484 C252,484 242,478 233,466 L203,424 C195,412 203,400 214,404 C222,407 230,416 239,428 Z" fill="#ffffff" stroke={NAVY} strokeWidth="12" strokeLinejoin="round" paintOrder="stroke" />
    </svg>
  );
}

/** Mark + "MusterTap" wordmark. `stacked` puts the mark above the name. */
export function Logo({ size = 28, stacked = false }: { size?: number; stacked?: boolean }) {
  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', flexDirection: stacked ? 'column' : 'row',
      gap: stacked ? size * 0.4 : size * 0.35,
    }}>
      <LogoMark size={stacked ? size * 2 : size * 1.15} />
      <span style={{ fontSize: size, fontWeight: 800, color: theme.text, letterSpacing: -0.5, lineHeight: 1 }}>
        Muster<span style={{ color: BLUE }}>Tap</span>
      </span>
    </div>
  );
}
